import React, { Component } from 'react';
import './RequestPasswordReset.css';
import Input from 'components/Input';
import AuthTop from 'components/AuthTop';
import AuthWrapper from 'components/AuthWrapper';
import AuthBottom from 'components/AuthBottom';
import Button from 'components/Button';
import FormErrors from 'components/FormErrors';
import { ERROR_SERVER_ERROR, ERROR_INVALID_EMAIL } from 'utils/constants';

const EMAIL_REGEX = RegExp(
  '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])' // eslint-disable-line no-control-regex
);

class RequestPasswordReset extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      errors: [],
      messages: [],
      submitting: false,
      successful: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  validate() {
    let errors = [];

    if (!EMAIL_REGEX.test(this.state.email)) {
      errors.push(ERROR_INVALID_EMAIL);
    }

    this.setState({ errors: errors });

    return errors.length === 0;
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ submitting: true });

    if (this.validate()) {
      this.setState({ messages: [] }, () => {
        return this.props
          .forgotPassword(this.state.email)
          .then(res => {
            this.setState({ submitting: false });
            if (res) {
              if (res.errors && res.errors.length > 0) {
                let errors = [];

                res.errors.forEach(err => {
                  if (err.message.includes(' : ')) {
                    let key = err.message.split(' : ')[1].replace(/ /g, '_');
                    errors.push(key);
                  }
                });

                this.setState({
                  submitting: false,
                  messages: errors
                });
              } else if (
                res.data &&
                res.data.forgotPassword &&
                res.data.forgotPassword.message
              ) {
                this.setState({
                  messages: [res.data.forgotPassword.message],
                  successful: true
                });
              } else {
                this.setState({
                  submitting: false
                });
              }
            }
            return res;
          })
          .catch(() => {
            this.setState({ messages: [ERROR_SERVER_ERROR] });
          });
      });
    }
  }

  handleChange(event) {
    this.setState({ email: event.target.value });
  }

  render() {
    return (
      <form className="forgot-password" onSubmit={this.handleSubmit}>
        <AuthWrapper>
          <AuthTop hideLogo>
            <h2>Reset Password</h2>
            {this.state.errors && <FormErrors errors={this.state.errors} />}
            {this.state.messages && <FormErrors errors={this.state.messages} />}
            {!this.state.successful && (
              <Input
                label="Email"
                type="email"
                name="email"
                meta={{ touched: false }}
                value={this.state.email}
                onChange={this.handleChange}
              />
            )}
          </AuthTop>
          {!this.state.successful && (
            <AuthBottom>
              <div className="login-bottom">
                <Button
                  disabled={this.state.submitting}
                  className="btn btn-success btn-block btn-square"
                >
                  <span>Submit</span>
                </Button>
              </div>
            </AuthBottom>
          )}
        </AuthWrapper>
      </form>
    );
  }
}

export default RequestPasswordReset;



// WEBPACK FOOTER //
// ./src/components/RequestPasswordReset/index.js